export default "__VITE_ASSET__D0SB$hjV__"